import { useState } from 'react';
import { FilterPriceRegionModal } from '@/components/Modals/FilterPriceRegionModal';
import { IBrandsPricingComparative } from '@/types/api/pricingsComparativeRegion';
import {
  Box,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Radio,
} from '@mui/material';

interface TBrandPricingComparative {
  selected: boolean;
  id: number | null;
  name: string;
}
interface IBrandComparativeFilterModalProps {
  isOpen: boolean;
  handleClose: () => void;
  brands: Array<IBrandsPricingComparative & { selected: boolean }>;
  onChangeBrand: (id: number | null) => void;
}

const BrandComparativeFilterModal = ({
  isOpen,
  handleClose,
  brands,
  onChangeBrand,
}: IBrandComparativeFilterModalProps) => {
  const [search, setSearch] = useState('');
  const [brandSelected, setBrandSelected] = useState(
    brands.find(brand => brand.selected)?.id || null
  );

  const defaultBrand: TBrandPricingComparative = {
    id: null,
    name: 'Todas as marcas',
    selected: true,
  };

  const currentBrands: TBrandPricingComparative[] = [defaultBrand].concat(
    brands.map(({ id, name, selected }) => ({
      id,
      name,
      selected,
    }))
  );

  return (
    <FilterPriceRegionModal
      title="Marcas"
      inputLabel="Pesquise por marca"
      open={isOpen}
      handleClose={handleClose}
      selectOption={brandSelected}
      onFilter={value => setSearch(value)}
      setOption={id => onChangeBrand(id as number | null)}
    >
      <>
        {currentBrands
          .filter(brand =>
            search
              ? brand.name.toLowerCase().includes(search.toLowerCase())
              : !search
          )
          .map(brand => (
            <Box key={brand.id}>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => setBrandSelected(brand.id)}
                  dense
                >
                  <ListItemIcon>
                    <Radio edge="start" checked={brand.id === brandSelected} />
                  </ListItemIcon>
                  <ListItemText primary={brand.name} />
                </ListItemButton>
              </ListItem>
              {brand.id === defaultBrand.id && <Divider />}
            </Box>
          ))}
      </>
    </FilterPriceRegionModal>
  );
};

export default BrandComparativeFilterModal;
export type { IBrandComparativeFilterModalProps };
